/* =====================================================================
   VITALIA PARIS — Vitalia.js
   JS minimal pour interactions theme
   ===================================================================== */

(function() {
  'use strict';

  // FAQ accordion
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.vp-faq__question');
    if (!btn) return;
    var item = btn.closest('.vp-faq__item');
    if (item) item.classList.toggle('is-open');
  });

  // Keep visual state, accessibility state and keyboard focus in sync.
  var drawerReturnFocus = null;
  function setDrawer(drawer, open) {
    var selector = '#' + drawer.id;
    var overlay = document.getElementById(drawer.id + '-overlay');
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    drawer.inert = !open;
    document.querySelectorAll('[data-drawer-toggle="' + selector + '"]').forEach(function(t) {
      t.setAttribute('aria-expanded', String(open));
    });
    if (overlay) overlay.classList.toggle('is-open', open);
    if (open) {
      drawerReturnFocus = document.activeElement;
      var first = drawer.querySelector('button, a[href]');
      if (first) first.focus();
    } else if (drawerReturnFocus && drawerReturnFocus.isConnected) {
      drawerReturnFocus.focus();
    }
  }
  document.addEventListener('click', function(e) {
    var toggle = e.target.closest('[data-drawer-toggle]');
    if (toggle) {
      var drawer = document.querySelector(toggle.getAttribute('data-drawer-toggle'));
      if (drawer) setDrawer(drawer, !drawer.classList.contains('is-open'));
      e.preventDefault();
    }
    if (e.target.closest('.drawer__overlay')) {
      document.querySelectorAll('.drawer.is-open, .cart-drawer.is-open').forEach(function(d) { setDrawer(d, false); });
    }
  });
  document.addEventListener('keydown', function(e) {
    var drawer = document.querySelector('.drawer.is-open, .cart-drawer.is-open');
    if (!drawer) return;
    if (e.key === 'Escape') { setDrawer(drawer, false); e.preventDefault(); }
    if (e.key === 'Tab') {
      var focusable = Array.from(drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex="0"]'));
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
      if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
    }
  });

  // Fade-in on scroll
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('[data-fade]').forEach(function(el) { io.observe(el); });
  }

  // Variant switcher
  document.addEventListener('change', function(e) {
    var radio = e.target.closest('[data-variant-input]');
    if (!radio) return;
    var form = radio.closest('form[data-product-form]');
    if (!form) return;
    var variantId = radio.value;
    var hidden = form.querySelector('[name="id"]');
    if (hidden) hidden.value = variantId;
  });

  // Quantity selectors
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-qty-action]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input[type="number"]');
    if (!input) return;
    var current = parseInt(input.value, 10) || 1;
    var min = parseInt(input.getAttribute('min'), 10) || 1;
    var max = parseInt(input.getAttribute('max'), 10) || 99;
    if (btn.dataset.qtyAction === 'increment' && current < max) input.value = current + 1;
    if (btn.dataset.qtyAction === 'decrement' && current > min) input.value = current - 1;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });


  // Ajout panier Shopify réel : conserve le panier et déclenche les événements natifs.
  // Suivi (06/10/2026) : avec l'attribut action présent au chargement, Shopify comptait chaque ajout au panier deux fois
  // (GA4 et Meta). L'action est retirée au chargement puis remise juste au moment de la soumission : un seul événement.
  // Sans JavaScript, le formulaire garde son action d'origine.
  document.querySelectorAll('form[data-vp-product-form][action]').forEach(function(f) {
    f.setAttribute('data-vp-action', f.getAttribute('action'));
    f.removeAttribute('action');
  });
  window.addEventListener('submit', function(e) {
    var f = e.target && e.target.closest ? e.target.closest('form[data-vp-action]') : null;
    if (f && !f.getAttribute('action')) f.setAttribute('action', f.getAttribute('data-vp-action'));
  }, true);
  document.addEventListener('submit', function(e) {
    var form = e.target.closest('[data-vp-product-form]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    var button = form.querySelector('button[type="submit"]');
    var errorBox = form.querySelector('.vp-product__cart-error');
    var label = button ? button.innerHTML : '';
    var variantId = parseInt(form.querySelector('[name="id"]').value, 10);
    var quantity = parseInt(form.querySelector('[name="quantity"]').value, 10) || 1;
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Ajout en cours…';
    }
    if (errorBox) {
      errorBox.hidden = true;
      errorBox.textContent = '';
    }
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }], sections: 'vp-cart-drawer', sections_url: window.location.pathname })
    }).then(function(response) {
      if (!response.ok) {
        return response.json().catch(function() { return {}; }).then(function(payload) {
          var reason = payload.description || payload.message || 'Cet article ne peut pas être ajouté pour le moment.';
          throw new Error(reason);
        });
      }
      return response.json();
    }).then(function(payload) {
      // Panier tiroir (06/10/2026) : on reste sur la page et le tiroir s'ouvre avec le panier à jour.
      if (window.VPCart && !/\/cart$/.test(window.location.pathname)) {
        if (button) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.innerHTML = label;
        }
        window.VPCart.afterAdd(payload);
        return;
      }
      // Sans tiroir : laisse aux pixels (GA4, Meta) le temps d'envoyer l'ajout avant de changer de page.
      setTimeout(function() { window.location.assign('/cart'); }, 700);
    }).catch(function(error) {
      if (button) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.innerHTML = label;
      }
      if (errorBox) {
        errorBox.textContent = error.message || 'Ajout au panier impossible pour le moment.';
        errorBox.hidden = false;
      }
    });
  });

})();
